var CompareListEventsService = (function () {
    function CompareListEventsService($timeout) {
        this.$timeout = $timeout;
        this.timeouts = [];
    }
    CompareListEventsService.prototype.registerTimeout = function (callback) {
        var timeout = this.$timeout(callback, 500);
        this.timeouts.push(timeout);
    };
    CompareListEventsService.prototype.cancelTimeouts = function () {
        var _this = this;
        this.timeouts.forEach(function (timeout) {
            _this.$timeout.cancel(timeout);
        });
        this.timeouts.length = 0;
    };
    CompareListEventsService.$inject = ['$timeout'];
    return CompareListEventsService;
}());
export { CompareListEventsService };
